import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoggedInUser } from '../../../../../../core/models/logged-in-user';

@Injectable({
    providedIn: 'root',
})
export class LoggedInUserStateService {
    /**
     * The current logged in user.
     */
    private readonly loggedInUser: BehaviorSubject<LoggedInUser | null> =
        new BehaviorSubject<LoggedInUser | null>(null);

    /**
     * Get the current logged in user as an Observable.
     */
    getLoggedInUser(): Observable<LoggedInUser | null> {
        return this.loggedInUser.asObservable();
    }

    /**
     * Set the current logged in user.
     */
    setLoggedInUser(user: LoggedInUser | null): void {
        this.loggedInUser.next(user);
    }
}
